import React from 'react'
import { observer } from 'mobx-react'

import Typography from '../../../UniformComponents/Typography'

const SectionHeader = observer(({ store }) => (
    <div className="pp-section-header-layout">
        <Typography type="h2" color="white">{store.activeSlide.title}</Typography>
    </div>
))

export default SectionHeader
